import { motion } from 'framer-motion';

interface SessionBannerProps {
  sessionType: 'presencial' | 'remota';
}

/**
 * Banner que indica que el juego está siendo jugado dentro de una sesión
 */
export default function SessionBanner({ sessionType }: SessionBannerProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="mb-6 bg-gradient-to-r from-green-500 to-emerald-600 text-white px-6 py-4 rounded-xl shadow-lg"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {sessionType === 'presencial' ? (
            <>
              <div className="w-3 h-3 bg-white rounded-full animate-pulse" />
              <p className="font-semibold text-lg">🟢 Sesión Presencial Activa</p>
            </>
          ) : (
            <>
              <div className="w-3 h-3 bg-white rounded-full animate-pulse" />
              <p className="font-semibold text-lg">📱 Sesión Remota</p>
            </>
          )}
        </div>
        <p className="text-sm opacity-90">
          Los resultados se guardarán automáticamente
        </p>
      </div>
    </motion.div>
  );
}
